import { IPromise, IScope } from 'angular'
import { Sale } from '../../../../models/sale'
import { $q } from '../../../../ng-compat/imports'

interface ServiceModalOptions {
  sale: Sale
}

/**
 * Controller class for service order customer modal
 *
 * @class ServiceModalController
 */
export class ServiceSaleRefundModalController {
  public readonly close: () => void
  private readonly internalClose: (val: IPromise<any>) => void

  constructor(
    $scope: IScope,
    close: (val: IPromise<any>) => void,
    public readonly options: ServiceModalOptions,
    private readonly vdEscapeStack: any
  ) {
    'ngInject'
    this.internalClose = close
    this.close = () => this.internalClose($q.reject())

    // Handle escape key
    this.vdEscapeStack.register(this.close)
    $scope.$on('$destroy', () => this.vdEscapeStack.deregister(this.close))
  }
}
